import React from "react";
import { Link } from "react-router-dom";

const CallToActionThree = () => {
  const handleSubmit = (event) => {
    event.preventDefault();
  };
  return (
    <div className="row align-items-center">
      <div className="col-lg-6">
        <div className="title-style-one">
          <h6 className="font-rubik" style={{ color: "#f96f60" }}>
            Demo gratuita.
          </h6>
          <h2>Contattaci per richiedere la tua demo gratuita</h2>
        </div>
        {/* /.title-style-one */}
      </div>
      {/* End .col */}

      <div className="col-lg-6">
        <div className="form-wrapper">
          <form onClick={handleSubmit}>
            <input type="text" placeholder="Indirizzo Email" />
            <button>Contattaci</button>
          </form>
          {/* End form */}
          <p className="font-rubik">
          Hai già un account? <Link to='#'
                            onClick={(e) => {
                                window.location.href = 'https://weco.beatdata.it';
                                e.preventDefault();
                            }}>Effettua la login.</Link>
          </p>
        </div>
        {/* /.form-wrapper */}
      </div>
      {/* End .col */}
    </div>
  );
};

export default CallToActionThree;
